import { useRef, forwardRef } from 'react';
import { useWindowVirtualizer } from '@tanstack/react-virtual';
import VirtualizedListView from '../virtualizedListView';
import { useScrollMargin } from '../../../../utility/hooks';
import {
  baseVirtualizedListPropTypes,
  virtualizerConfigPropTypes,
} from '../propTypes';

const WindowVirtualizedList = forwardRef((props, ref) => {
  const { count, gap, estimateSize, getItemKey, virtualizerRef, ...viewProps } =
    props;

  const viewportRef = useRef(null);
  const scrollMargin = useScrollMargin(viewportRef);

  const virtualizer = useWindowVirtualizer({
    getItemKey,
    scrollMargin,
    overscan: 5,
    count,
    gap,
    estimateSize,
  });

  return (
    <VirtualizedListView
      {...viewProps}
      ref={ref}
      virtualizer={virtualizer}
      virtualizerRef={virtualizerRef}
      usesExternalScroll
      viewportRef={viewportRef}
    />
  );
});

WindowVirtualizedList.displayName = 'WindowVirtualizedList';

WindowVirtualizedList.propTypes = {
  ...baseVirtualizedListPropTypes,
  ...virtualizerConfigPropTypes,
};

export default WindowVirtualizedList;
